/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_Browser_ExtensionInputs */

const en_footer_link_browser_extension = /** @type {(inputs: Footer_Link_Browser_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser Extension`)
};

const es_footer_link_browser_extension = /** @type {(inputs: Footer_Link_Browser_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensión del navegador`)
};

/**
* | output |
* | --- |
* | "Browser Extension" |
*
* @param {Footer_Link_Browser_ExtensionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const footer_link_browser_extension = /** @type {((inputs?: Footer_Link_Browser_ExtensionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_Browser_ExtensionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_link_browser_extension(inputs)
	return en_footer_link_browser_extension(inputs)
});